import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import WoffEmbeddedIcon from 'components/WoffEmbeddedIcon';

const Icon = createReactClass({
  propTypes: {
    woff: PropTypes.string,
    class_name: PropTypes.string,
  },

  mixins: [ImmutableRenderMixin],

  render() {
    const {woff} = this.props;
    let value = null;

    if (woff) {
      value =  (
        <WoffEmbeddedIcon className={this.props.class_name} woff={this.props.woff} />
      );
    }

    return value;
  },
});

export default Icon;



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/Icon.js